// Generated by genversion.
export const version = '1.8.0';
